/* Syrup Oracle: back-in-stock, house-branded.
   The notify trigger is the store's own button — Klaviyo's injected BIS
   button is not used (off-brand, un-themable from the theme). Click reveals
   an email row; submit posts directly to Klaviyo's client Back-in-Stock API
   (public company id, safe in page source — no private key), which
   subscribes the profile to the selected variant so the live BIS flow emails
   them on restock. If the API is unreachable (adblock, offline), reveal the
   legacy contact-form path so the customer still has a road.
   All listeners are delegated: the block lives in Vue-managed DOM and is
   torn down / re-rendered on variant change. */
(function () {
  'use strict';

  var COMPANY_ID = 'RJG8HX'; /* public Klaviyo site id — matches the onsite embed */
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID;

  function fallback(root) {
    var wrap = root.closest('.out-of-stock-form');
    var legacy = wrap && wrap.querySelector('[data-so-bis-fallback]');
    if (legacy) {
      root.hidden = true;
      legacy.hidden = false;
    } else {
      setStatus(root, 'The notify list is unreachable right now — email support@bgreynolds.com and we’ll add you by hand.', false);
    }
  }

  function setStatus(root, msg, ok) {
    var status = root.querySelector('[data-so-bis-status]');
    if (!status) return;
    status.textContent = msg;
    status.classList.toggle('so-bis-status--ok', !!ok);
    status.hidden = false;
  }

  function subscribe(root) {
    var input = root.querySelector('[data-so-bis-email]');
    var send = root.querySelector('[data-so-bis-send]');
    var variantId = root.getAttribute('data-variant-id');
    var email = input ? input.value.trim() : '';

    if (!input || !variantId) { fallback(root); return; }
    if (!email || !input.checkValidity()) {
      setStatus(root, 'That address doesn’t look right — check it and try again.', false);
      input.focus();
      return;
    }

    if (send) send.disabled = true;
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
            }
          }
        }
      })
    }).then(function (res) {
      if (res.ok) {
        var capture = root.querySelector('[data-so-bis-capture]');
        var fineprint = root.querySelector('[data-so-bis-fineprint]');
        if (capture) capture.hidden = true;
        if (fineprint) fineprint.hidden = true;
        setStatus(root, 'You’re on the list. One email when it’s back on the shelf — that’s the whole correspondence.', true);
      } else {
        if (send) send.disabled = false;
        fallback(root);
      }
    }).catch(function () {
      if (send) send.disabled = false;
      fallback(root);
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var open = e.target.closest('[data-so-bis-open]');
    if (open) {
      var root = open.closest('[data-so-bis-native]');
      var capture = root && root.querySelector('[data-so-bis-capture]');
      if (!capture) return;
      open.hidden = true;
      capture.hidden = false;
      var input = capture.querySelector('[data-so-bis-email]');
      if (input) input.focus();
      return;
    }
    var send = e.target.closest('[data-so-bis-send]');
    if (send) subscribe(send.closest('[data-so-bis-native]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target && e.target.matches && e.target.matches('[data-so-bis-email]') ? e.target : null;
    if (!input) return;
    e.preventDefault();
    subscribe(input.closest('[data-so-bis-native]'));
  });
})();
